import { API } from 'aws-amplify'

export default {
  createReport: ({ organizationName, body }) =>
    API.post('ReporterAPI', `/organizations/${organizationName}/reports`, {
      body
    }),
  getReport: ({ organizationName, caseName, password }) =>
    API.post(
      'ReporterAPI',
      `/organizations/${organizationName}/reports/${caseName}`,
      {
        body: {
          password
        }
      }
    ),

  createCaseMessage: ({ organizationName, caseName, password, value }) =>
    API.post(
      'ReporterAPI',
      `/organizations/${organizationName}/reports/${caseName}/messages`,
      {
        body: { value, password }
      }
    )
}
